module.exports = __webpack_public_path__ + "static/media/profile-cover.321898bf.jpg";